import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Chip, Box } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      maxWidth: 345
    },
    contentContainer: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    media: {
      height: 208
    },
    chip: {
      marginTop: theme.spacing(-2.5),
      marginLeft: theme.spacing(3),
      color: theme.palette.secondary[900],
      background: theme.palette.secondary[50]
    }
  };
});
var useTrialStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, theme.breakpoints.up("xs"), {
      width: 300
    }), theme.breakpoints.up("sm"), {
      width: 350
    }), "height", "100%"), "borderRadius", "80px 80px 18px 18px"), "display", "flex"), "flexDirection", "column"), "border", "1px solid #DCECF8"),
    contentContainer: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    indexIndicatorWrapper: {
      width: theme.spacing(7.5),
      height: theme.spacing(7.5),
      backgroundColor: "#DCECF8",
      position: "absolute",
      borderRadius: theme.spacing(4.5),
      transform: "translateX(-16px)"
    },
    indexIndicator: {
      fontSize: theme.spacing(3.75),
      fontFamily: "Josefin Sans, sans-serif;",
      fontWeight: "300",
      display: "block",
      textAlign: "center",
      margin: theme.spacing(1.25, 0)
    },
    media: {
      height: 208
    },
    overtitle: {
      color: theme.palette.text.medium
    },
    subtitle: {
      color: theme.palette.secondary[500]
    },
    content: {
      "& ul": {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
      }
    },
    footer: {
      background: "#DCECF8",
      flexDirection: "column",
      alignItems: "end",
      marginTop: "auto"
    },
    chip: {
      width: "fit-content",
      marginTop: theme.spacing(-2.5),
      marginLeft: theme.spacing(3),
      color: theme.palette.secondary[900],
      background: theme.palette.secondary[50]
    }
  };
});
var useTrialFutureBookingStyles = makeStyles(function (theme) {
  return {
    root: {
      maxWidth: 149,
      height: "100%",
      borderRadius: "40px 40px 8px 8px",
      display: "flex",
      flexDirection: "column",
      border: "2px dashed",
      borderColor: theme.palette.secondary[200]
    },
    contentContainer: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      height: "100%"
    },
    indexIndicatorWrapper: {
      width: theme.spacing(7.5),
      height: theme.spacing(7.5),
      backgroundColor: "#DCECF8",
      position: "absolute",
      borderRadius: theme.spacing(4.5),
      transform: "translateX(-16px)"
    },
    indexIndicator: {
      fontSize: theme.spacing(3.75),
      fontFamily: "Josefin Sans, sans-serif;",
      fontWeight: "300",
      display: "block",
      textAlign: "center",
      margin: theme.spacing(1.25, 0)
    }
  };
});
var MediaCard = function MediaCard(_ref) {
  var className = _ref.className,
    contentClassName = _ref.contentClassName,
    image = _ref.image,
    chip = _ref.chip,
    title = _ref.title,
    overtitle = _ref.overtitle,
    subtitle = _ref.subtitle,
    content = _ref.content,
    indexIndicator = _ref.indexIndicator,
    footer = _ref.footer,
    footerClassName = _ref.footerClassName,
    elevation = _ref.elevation,
    variant = _ref.variant,
    onClick = _ref.onClick;
  var classes;
  if (variant === "trial") {
    classes = useTrialStyles();
  } else if (variant === "trialFutureBooking") {
    classes = useTrialFutureBookingStyles();
  } else {
    classes = useStyles();
  }
  var handleClick = function handleClick() {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/React__default.createElement(Card, {
    onClick: handleClick,
    className: className ? clsx(className, classes.root) : classes.root,
    elevation: elevation
  }, indexIndicator && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.isValidElement(indexIndicator) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, indexIndicator) : /*#__PURE__*/React__default.createElement("div", {
    className: classes.indexIndicatorWrapper
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    className: classes.indexIndicator
  }, indexIndicator))), image && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    className: clsx(image.className, classes.media),
    src: image.url,
    title: image.title,
    alt: image.alt
  }), chip && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.isValidElement(chip) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, chip) : /*#__PURE__*/React__default.createElement(Chip, {
    label: chip,
    className: classes.chip
  })), /*#__PURE__*/React__default.createElement(CardContent, {
    className: contentClassName ? contentClassName : classes.contentContainer
  }, /*#__PURE__*/React__default.isValidElement(overtitle) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, overtitle) : /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1",
    component: "div",
    className: classes.overtitle
  }, overtitle), /*#__PURE__*/React__default.isValidElement(title) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title) : /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h2",
    component: "div"
  }, title), /*#__PURE__*/React__default.isValidElement(subtitle) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, subtitle) : /*#__PURE__*/React__default.createElement(Typography, {
    variant: "overline",
    className: classes.subtitle
  }, subtitle), content && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React__default.isValidElement(content) ? /*#__PURE__*/React__default.createElement(Box, {
    className: classes.content
  }, content) : /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    className: classes.content
  }, content)))), /*#__PURE__*/React__default.isValidElement(footer) && /*#__PURE__*/React__default.createElement(CardActions, {
    className: footerClassName ? footerClassName : classes.footer
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, footer)));
};
var types = {
  className: PropTypes__default.any,
  footerClassName: PropTypes__default.any,
  elevation: PropTypes__default.number,
  image: PropTypes__default.shape({
    url: PropTypes__default.string,
    title: PropTypes__default.string,
    className: PropTypes__default.any,
    alt: PropTypes__default.string
  }),
  chip: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  overtitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  subtitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  content: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  indexIndicator: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  footer: PropTypes__default.element,
  variant: PropTypes__default.oneOf(["default", "trial", "trialFutureBooking"]),
  contentClassName: PropTypes__default.any,
  onClick: PropTypes__default.func
};
MediaCard.propTypes = types;

export { MediaCard as default, types };
//# sourceMappingURL=MediaCard.js.map
